import { Button } from "../src/platform/components/buttons/Button";
import DemystLogo from "../src/landingPage/assets/svg/DemystLogo.svg";
import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";

function Custom404() {
  return (
    <main className="Error404">
      <NextHead title="Page not found" />
      <article className="Error404__content">
        <img
          src={DemystLogo.src}
          className="layout-header-logo-img"
          alt="Demyst"
          loading="eager"
          height="40"
          width="162"
        />

        <small>404</small>
        <h1>Page not found</h1>
        <h2>Sorry, we can&apos;t find what you&apos;re looking for.</h2>
        <a href="/" className="Error404__content__button">
          <Button>Return Home</Button>
        </a>
      </article>
    </main>
  );
}

export default Custom404;
